angular.module('app').component('adminSwitch', {
    templateUrl: 'events/components/switch.html',
    transclude: {
        descriptionContent: '?adminSwitchDescription'
    },
    bindings: {
        ariaLabel: '@?switchAriaLabel',
        checked: '<?',
        description: '@?',
        model: '=?',
        onClick: '&',
        title: '@?'
    },
    controller: ['$attrs', '$transclude', function($attrs, $transclude) {
        var main = this;

        main.hasDescriptionContent = $transclude.isSlotFilled('descriptionContent');
        main.usesModel = angular.isDefined($attrs.model);

        main.handleClick = function(event) {
            main.onClick({$event: event});
        };
    }]
});
